import { render, staticRenderFns } from "./SavedListsPanel.vue?vue&type=template&id=2d5f20b0&"
import script from "./SavedListsPanel.vue?vue&type=script&lang=js&"
export * from "./SavedListsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports